import { useEffect, useRef } from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';
import { useHealthyDealsDataContext } from '../HealthyDealsDataContextProvider/HealthyDealsData.context';
import { mainPageMetaDescription } from '../../utils/miscConstants';

export default function RootLayout() {
	const {
		setMainTitleTo,
		description = 'Discounts on products and services to help support your health and fitness journey.',
		setTopHeadingElementRef,
		updatePageTitleAndDescription,
	} = useHealthyDealsDataContext();
	const topHeadingElementRef = useRef(null);

	useEffect(() => {
		setTopHeadingElementRef(topHeadingElementRef);
		updatePageTitleAndDescription(setMainTitleTo, mainPageMetaDescription);
		return () => setTopHeadingElementRef(null);
	}, [setTopHeadingElementRef]);

	return (
		<>
			<Stack spacing={3} mb={5}>
				<Typography
					variant="h3"
					component="h1"
					gutterBottom
					color="primary"
					ref={topHeadingElementRef}
				>
					{setMainTitleTo}
				</Typography>
				{description && (
					<Typography variant="body2" component="h2" gutterBottom>
						{description}
					</Typography>
				)}
			</Stack>
			<Outlet />
		</>
	);
}
RootLayout.propTypes = {
	description: PropTypes.string,
};
